__turbopack_context__.v({
  "breakAll": "styles-module-scss-module__V3slLq__breakAll",
  "root": "styles-module-scss-module__V3slLq__root",
  "text": "styles-module-scss-module__V3slLq__text",
  "textLightMode": "styles-module-scss-module__V3slLq__textLightMode",
});
